import React, { ChangeEvent } from "react";
import "./OwIconButton.scss";

type Props = {
    iconClass: string;
    iconColorClass: string;
    fn: (e?: ChangeEvent<any>) => void;
    title?: string;
    disabled?: boolean;
};

export const OwIconButton: React.FC<Props> = (props) => {
    const fn = () => {
        if (props.fn && !props.disabled) {
            props.fn();
        }
    };

    const onMouseDown = (e: any) => {
        e.stopPropagation();
    };

    return (
        <i
            className={props.iconColorClass + " OwIconButton pointer " + props.iconClass}
            onClick={fn}
            onMouseDown={onMouseDown}
            title={props.title}
        />
    );
};
